export const SOURCE_LABELS = { "job-request": "request", job: "job", emergency: "emergency", project: "project", quote: "quote" };

export const stripClient = (name = "") => (name || "").replace(/\s*\(Client\)\s*$/i, "");

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "");

export const dayKey = (iso) => (iso ? new Date(iso).toDateString() : "");

export function dayLabel(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return "Today";
  const y = new Date(today);
  y.setDate(today.getDate() - 1);
  if (d.toDateString() === y.toDateString()) return "Yesterday";
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", ...(d.getFullYear() !== today.getFullYear() ? { year: "numeric" } : {}) });
}

export function sourceLabel(source) {
  if (!source?.linked) return "";
  return `From ${SOURCE_LABELS[source.etype] || source.etype} ${source.reference || ""}`.trim();
}
